import { connect } from 'react-redux';

import HeaderBottom from '../../../../../../components/Templates/A/Header/components/HeaderBottom';

const mapStateToProps = ({ app }) => ({
  menu: app.getIn(['header', 'menu'], []),
  isSearchBox: app.getIn(['header', 'openSearchBox'], false),
});

export default connect(mapStateToProps)(HeaderBottom);
